<app-manage-users [cartegraphEnabled]="cartegraphEnabled"></app-manage-users>
